"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var OrgChart_1 = require("./OrgChart");
var react_transition_group_1 = require("react-transition-group");
var Animated = /** @class */ (function (_super) {
    __extends(Animated, _super);
    function Animated() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            entered: false,
        };
        return _this;
    }
    Animated.prototype.render = function () {
        var _this = this;
        var _a = this.props, node = _a.node, context = _a.context, props = _a.props, getStyle = _a.getStyle, _b = _a.duration, duration = _b === void 0 ? 500 : _b;
        var entered = this.state.entered;
        var style = getStyle ? getStyle(node, props, context) : null;
        var defaultStyle = {
            transition: entered
                ? "opacity " + duration + "ms, \n           width " + duration + "ms, \n           height " + duration + "ms, \n           transform " + duration + "ms"
                : "opacity " + duration + "ms",
            opacity: 0,
        };
        var transitionStyles = {
            entering: { opacity: 0 },
            entered: { opacity: 1 },
            exiting: { opacity: 0 },
            exited: { opacity: 0 },
        };
        var visible = context.drawStage === OrgChart_1.DrawStage.RENDER ||
            context.drawStage === OrgChart_1.DrawStage.MEASURE_VISIBLE;
        return (react_1.default.createElement(react_transition_group_1.Transition, { in: entered || visible, appear: visible, timeout: duration, exit: false, onEntered: function () { return _this.setState({ entered: true }); } }, function (state) {
            return (react_1.default.createElement("div", __assign({}, props, { style: __assign(__assign(__assign(__assign({}, props.style), defaultStyle), transitionStyles[state]), style) })));
        }));
    };
    return Animated;
}(react_1.default.Component));
exports.default = Animated;
